import { formatFormFieldReport } from '../ProblemsReporter.js';

export const execute = (node, context) => {

  const {
    executionPlatformLabel,
    reporter,
    category
  } = context;

  if (node.type !== 'iframe' || !node.security) {
    return true;
  }

  if (node.security.allowScripts === false) {
    const errorMessage = `Security attributes are not supported by ${executionPlatformLabel}, scripts cannot be disabled`;
    reporter.report(formatFormFieldReport(node, errorMessage, category));
  }

  const isAnyOtherSecurityAttributeSet = Object.keys(node.security).some(key => key !== 'allowScripts' && node.security[key] === true);

  if (isAnyOtherSecurityAttributeSet) {
    const errorMessage = `Security attributes are not supported by ${executionPlatformLabel}`;
    reporter.report(formatFormFieldReport(node, errorMessage, category));
  }

  return true;
};
